import { useNavigate } from "react-router-dom";
import React from "react";

const Start_Main_SignIn_NoAccount = (props) => {
    let navigate = useNavigate();
    const handleClick = () => {
        navigate("/start/signup");
    }
    return(
        <div className="start_main_signIn_noAccount">
            <p className="start_main_signIn_noAccount_text">Don't have an account?</p><button className="start_main_signIn_noAccount_button" onClick={handleClick}>Sign up</button>
        </div>
    )
}

export default Start_Main_SignIn_NoAccount;